var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import React from "react";
import ImageIcon from "@mui/icons-material/Image";
import { ST_CustName_TableCell, ST_Product_Image_CSS, ST_Table_CSS } from "../../../css/NavigationObjectCss";
import { SharedFunctions } from "../../SharedFunctions";
import { PendingOrdersBL } from "./PendingOrdersBL";
import { formatAmount } from "../../../shared/Utilites";
import OrderActionsMenu from "../OrderActionsMenu";
var MobileViewPendingOrder = function (props) {
    var tableType = props.tableType, headerArray = props.headerArray, dataArray = props.dataArray, getProductData = props.getProductData;
    //tableType=1 -> pending order and 2-> product
    var _a = PendingOrdersBL(), shopCurrency = _a.shopCurrency, currency = _a.currency, t = _a.t, menuAnchorEl = _a.menuAnchorEl, selectedOrder = _a.selectedOrder, handleMenuClick = _a.handleMenuClick, handleMenuClose = _a.handleMenuClose, handleDuplicateOrder = _a.handleDuplicateOrder;
    var getDateFormat = SharedFunctions().getDateFormat;
    var getDynamicTableCellForPendingOrder = function (headerIndex, item) {
        var returnCell;
        switch (headerIndex) {
            case 0:
                returnCell = (_jsx(TableCell, __assign({ sx: ST_CustName_TableCell, onClick: function () {
                        getProductData(item);
                    } }, { children: item === null || item === void 0 ? void 0 : item.orderNumber })));
                break;
            case 1:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.CustomerName) || "-" });
                break;
            case 2:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.B2BCompanyName) || "-" });
                break;
            case 3:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.B2BLocationName) || "-" });
                break;
            case 4:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.orderDate) || "-" });
                break;
            case 5:
                returnCell = (_jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item === null || item === void 0 ? void 0 : item.subtotal, currency, shopCurrency) })));
                break;
            case 6:
                returnCell = _jsx(TableCell, { children: "Unpaid" });
                break;
            case 7:
                returnCell = (_jsx(TableCell, __assign({ sx: { display: "flex", justifyContent: "flex-start" } }, { children: _jsx(OrderActionsMenu, { item: item, menuAnchorEl: menuAnchorEl, selectedOrder: selectedOrder, onMenuClick: handleMenuClick, onMenuClose: handleMenuClose, orderIdField: "OrderId", menuItems: [
                            {
                                label: t("yourSales_Duplicate"),
                                onClick: handleDuplicateOrder,
                                disabled: item === null || item === void 0 ? void 0 : item.B2BCompanyName
                            },
                        ] }) })));
                break;
        }
        return returnCell;
    };
    var getDynamicTableCellForProduct = function (headerIndex, item) {
        var returnCell;
        switch (headerIndex) {
            case 0:
                returnCell = (_jsx(TableCell, __assign({ scope: "row" }, { children: (item === null || item === void 0 ? void 0 : item.Image) ? _jsx(Box, { component: "img", sx: ST_Product_Image_CSS, src: item.Image }) : _jsx(ImageIcon, { sx: { height: 50, width: 50 } }) })));
                break;
            case 1:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.Title) || "-" });
                break;
            case 2:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.variantTitle) || "-" });
                break;
            case 3:
                returnCell = _jsx(TableCell, { children: item.SKU || "-" });
                break;
            case 4:
                returnCell = _jsx(TableCell, { children: item.quantity });
                break;
            case 5:
                returnCell = (_jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item === null || item === void 0 ? void 0 : item.ItemPrice, currency, shopCurrency) })));
                break;
            case 6:
                returnCell = (_jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item === null || item === void 0 ? void 0 : item.discountedPrice, currency, shopCurrency) })));
                break;
            case 7:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.trackingNumber) || "-" });
                break;
            case 8:
                returnCell = _jsx(TableCell, { children: getDateFormat(item === null || item === void 0 ? void 0 : item.ShipDate) });
                break;
            case 9:
                returnCell = (_jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item === null || item === void 0 ? void 0 : item.Subtotal, currency, shopCurrency) })));
                break;
        }
        return returnCell;
    };
    var pendingOrderPopUp = function () {
        var tableStructure = (_jsx(TableContainer, __assign({ sx: ST_Table_CSS, className: "Table_Container_Margin" }, { children: _jsx(Table, { children: dataArray !== null && dataArray !== undefined && (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 ? (dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(function (item, index) { return (_jsxs(_Fragment, { children: [_jsx(TableBody, __assign({ sx: { backgroundColor: "whitesmoke" } }, { children: _jsx(React.Fragment, { children: headerArray === null || headerArray === void 0 ? void 0 : headerArray.map(function (header, headerIndex) { return (_jsxs(TableRow, __assign({ className: "MobileViewTableCell", sx: { display: (header === null || header === void 0 ? void 0 : header.hidden) ? "none" : "table-row" } }, { children: [_jsx(TableCell, { children: _jsxs("b", { children: [header.label, " :"] }) }), getDynamicTableCellForPendingOrder(headerIndex, item)] }), header.label + headerIndex)); }) }, index) })), _jsx("br", {})] })); })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: "BorderBottom" }, { children: t("no_orders_to_show") })) }) })) }) })));
        return tableStructure;
    };
    var productDetailPopup = function () {
        var tableStructure = (_jsx(TableContainer, { children: _jsx(Table, { children: dataArray !== null && dataArray !== undefined && (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 ? (dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(function (item, index) { return (_jsxs(_Fragment, { children: [_jsx(TableBody, __assign({ sx: { backgroundColor: "whitesmoke" } }, { children: _jsx(React.Fragment, { children: headerArray === null || headerArray === void 0 ? void 0 : headerArray.map(function (header, headerIndex) { return (_jsxs(TableRow, __assign({ className: "MobileViewTableCell", sx: { display: (header === null || header === void 0 ? void 0 : header.hidden) ? "none" : "table-row" } }, { children: [_jsx(TableCell, { children: _jsxs("b", { children: [header.label, " :"] }) }), getDynamicTableCellForProduct(headerIndex, item)] }), header.label + headerIndex)); }) }, index) })), _jsx("br", {})] })); })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: "BorderBottom" }, { children: t("no_product_details") })) }) })) }) }));
        return tableStructure;
    };
    return tableType === "1" ? pendingOrderPopUp() : productDetailPopup();
};
export default MobileViewPendingOrder;
